<div class="story-list-item col-12">
    <div class="image" style="{{'background-color:'+bgColor+';'}}">
        <img [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +imgSrc ">
    </div>
    <div class="logo">

        <img [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +logoSrc ">
    </div>
    <p class="text">
        {{text}}
    </p>

    <div class="lnk" >
        <button style="border-width: 0px;padding: 0px;margin: 0px;" class="button link-btn" (click)="goToSuccessPage(uid)" >
            <span i18n="@@Full story">Full story</span>
            <i *ngIf="getDirection() == 'rtl'" class="pi pi-angle-left"></i>
            <i *ngIf="getDirection() == 'ltr'" class="pi pi-angle-right"></i>
        </button>
    </div>

</div>
